/**
 * Single source of truth for the Developer Tools tabs — the shell derives its tab bar from this
 * array and the router derives one nested route per entry. Later slices append API Explorer and
 * Configurations here; a `requiredRole` gates a tab's route (Configurations will be Super Admin).
 */
export interface DeveloperToolsTab {
  label: string;
  path: string;
  pageId: string;
  requiredRole?: string[];
}

export const DEVELOPER_TOOLS_TABS: readonly DeveloperToolsTab[] = [
  { label: "API Keys", path: "api-keys", pageId: "developer-tools-api-keys" },
  { label: "API Explorer", path: "api-explorer", pageId: "developer-tools-api-explorer" },
];
